import { render, staticRenderFns } from "./defectSolutionPrevalence.vue?vue&type=template&id=2771f0dd&scoped=true"
import script from "./defectSolutionPrevalence.vue?vue&type=script&lang=js"
export * from "./defectSolutionPrevalence.vue?vue&type=script&lang=js"
import style0 from "./defectSolutionPrevalence.vue?vue&type=style&index=0&id=2771f0dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771f0dd",
  null
  
)

export default component.exports